/** Formes de remise prises en charge par le moteur promotionnel. */
export const PROMOTION_DISCOUNT_TYPES = [
    'percentage',
    'fixed',
    'free_shipping',
    'free_kg',
    'gift',
];
/** Verdicts stables de l'évaluation d'éligibilité. */
export const PROMOTION_DECISION_CODES = [
    'ok',
    'inactive',
    'not_started',
    'expired',
    'minimum_not_met',
    'usage_exhausted',
];
/** États persistables d'une réservation de code promotionnel. */
export const PROMOTION_RESERVATION_STATUSES = ['reserved', 'consumed', 'released'];
/** Actions pures à traduire en écriture transactionnelle par l'adaptateur. */
export const PROMOTION_SETTLEMENT_ACTIONS = ['none', 'consume', 'release'];
/** Durée historique d'une réservation checkout avant purge TTL. */
export const PROMOTION_RESERVATION_TTL_MS = 2 * 60 * 60 * 1000;
